import request from "../../../utils/request";

function createExecutiveEvaluation(data) {
  return request({
    url: '/admin/send-executive-evaluation',
    method: 'POST',
    data
  });
}

function getStatusExecutiveEvaluation(data) {
  return request({
    url: '/admin/status-executive-evaluation',
    method: 'POST',
    data
  });
}
  
const ApiExecutiveEvaluation = {
  createExecutiveEvaluation,
  getStatusExecutiveEvaluation
};

export default ApiExecutiveEvaluation;